import {
  PaymentsApiErrorCodes,
  PaymentsApiErrorResponse,
  PaymentsApiException,
} from '@kotipizzagroup/kotipizza-payments-api-admin-client';

const paymentsApiErrorMessages: Record<PaymentsApiErrorCodes, string> = {
  [PaymentsApiErrorCodes.GenericUnknownError]: 'Odottamaton virhe maksussa. Yritä hetken päästä uudelleen.',
  [PaymentsApiErrorCodes.GenericOrderNotFound]: 'Tilausta ei löytynyt. Otathan yhteyttä asiakaspalveluun.',
  [PaymentsApiErrorCodes.GenericOrderAlreadyPaid]:
    'Tilaus on jo maksettu. Tilausvahvistuksen pitäisi löytyä sähköpostista.',
  [PaymentsApiErrorCodes.GenericNoRestaurantFound]: 'Virhe ravintolan hakemisessa.',
  [PaymentsApiErrorCodes.GenericMerchantNotFound]:
    'Virhe ravintolan kauppiastunnuksessa. Otathan yhteyttä asiakaspalveluun.',
  [PaymentsApiErrorCodes.GenericConnectionError]: 'Yhteysvirhe. Yritä hetken päästä uudelleen.',
  [PaymentsApiErrorCodes.GenericSumMismatch]: 'Tilauksen summa ei täsmää.',
  [PaymentsApiErrorCodes.GenericSplitPaymentError]: 'Virhe usean maksutavan tilauksessa.',
  [PaymentsApiErrorCodes.GenericMerchantNotActive]:
    'Virhe maksun käsittelyssä. Ravintolan kauppiastunnus ei ole aktiivinen.',
  [PaymentsApiErrorCodes.AdyenAmountIsMissing]: 'Tilauksen summa puuttuu tai se on virheellinen.',
  [PaymentsApiErrorCodes.AdyenInvalidCardNumber]: 'Virheellinen maksukortin numero.',
  [PaymentsApiErrorCodes.AdyenInvalidCardVariant]: 'Valitettavasti tämä maksukortti ei käy verkkokaupassa.',
  [PaymentsApiErrorCodes.AdyenCVCInvalidLength]: 'Syöttämäsi CVC-tarkistusnumero on liian lyhyt.',
  [PaymentsApiErrorCodes.AdyenInvalidBillingAddress]: 'Ongelma syöttämäsi osoitteen kanssa.',
  [PaymentsApiErrorCodes.AdyenRecurringNotEnabled]:
    'Toistuvia maksuja ei ole kytketty päälle valitsemassasi ravintolassa.',
  [PaymentsApiErrorCodes.AdyenInvalidBankAccountNumber]: 'Ongelma tilinumeron kanssa.',
  [PaymentsApiErrorCodes.AdyenBankDetailsMissing]: 'Ongelma tai puute maksutiedoissa.',
  [PaymentsApiErrorCodes.AdyenInvalidBankCountryCode]: 'Valitettavasti tämä maksukortti ei käy verkkokaupassa.',
  [PaymentsApiErrorCodes.AdyenBankCountryNotSupported]: 'Valitettavasti käyttämäsi pankki ei käy verkkokaupassa.',
  [PaymentsApiErrorCodes.AdyenInvalidDateOfBirth]: 'Syntymäpäivä on väärässä muodossa.',
  [PaymentsApiErrorCodes.AdyenInvalidDeliveryAddress]: 'Syöttämäsi osoite näyttää olevan väärässä muodossa.',
  [PaymentsApiErrorCodes.AdyenInvalidShopperName]: 'Nimi on syötetty väärässä muodossa.',
  [PaymentsApiErrorCodes.AdyenShopperEmailNotProvided]: 'Pakollinen sähköpostiosoite puuttuu.',
  [PaymentsApiErrorCodes.AdyenTelephoneNumberNotProvided]: 'Pakollinen puhelinnumero puuttuu.',
  [PaymentsApiErrorCodes.AdyenInvalidPhoneNumber]: 'Syöttämäsi puhelinnumero on virheellinen.',
  [PaymentsApiErrorCodes.AdyenAccountHolderNameNotProvided]: 'Tilin omistajan tiedot ovat puutteelliset.',
  [PaymentsApiErrorCodes.AdyenCardHolderNameNotProvided]: 'Maksukortin omistajan tiedot ovat puutteelliset.',
  [PaymentsApiErrorCodes.AdyenExpiryDateInvalid]: 'Virhe syöttämäsi maksukortin tiedoissa.',
  [PaymentsApiErrorCodes.AdyenAmountIsNotValid]: 'Virhe tilauksen summan tarkistuksessa.',
  [PaymentsApiErrorCodes.AdyenCurrencyIsNotValid]: 'Tilauksella on väärä valutta.',
  [PaymentsApiErrorCodes.AdyenCVCInvalid]: 'Virhe syöttämäsi maksukortin tiedoissa.',
  [PaymentsApiErrorCodes.AdyenAmountNotAllowedForOperation]: 'Virhe tilauksen summan tarkistuksessa.',
  [PaymentsApiErrorCodes.AdyenInvalidShopperEmail]: 'Syöttämäsi sähköpostiosoite on virheellinen.',
  [PaymentsApiErrorCodes.AdyenInvalidMerchantAccount]:
    'Virhe ravintolan kauppiastunnuksessa. Ota yhteyttä asiakaspalveluun.',
  [PaymentsApiErrorCodes.AdyenTransactionExceedsAllowedLimit]: 'Summa ylittää sallitun rajan.',
  [PaymentsApiErrorCodes.AdyenApplePayTokenAmountMismatch]: 'Virhe Apple Pay -maksun tarkistuksessa.',
  [PaymentsApiErrorCodes.AdyenGooglePayTokenExpired]: 'Google Pay -maksu vanhentui. Yritä hetken päästä uudestaan.',
  [PaymentsApiErrorCodes.AdyenRefusalRefused]: 'Maksua ei hyväksytty. Kokeile toista maksutapaa.',
  [PaymentsApiErrorCodes.AdyenRefusalCardBlocked]: 'Tilausta ei hyväksytty. Kokeile toista maksutapaa.',
  [PaymentsApiErrorCodes.AdyenRefusalCardExpired]: 'Syöttämäsi maksukortti on vanhentunut. Kokeile toista maksutapaa.',
  [PaymentsApiErrorCodes.AdyenRefusalInvalidAmount]: 'Virhe tilauksen summan tarkistuksessa.',
  [PaymentsApiErrorCodes.AdyenRefusalInvalidCardNumber]: 'Virhe syöttämäsi maksukortin tiedoissa.',
  [PaymentsApiErrorCodes.AdyenRefusalIssuerUnavailable]: 'Yhteysongelma pankin kanssa. Yritä hetken päästä uudestaan.',
  [PaymentsApiErrorCodes.AdyenRefusalNotSupported]: 'Maksutapa ei ole tuettu.',
  [PaymentsApiErrorCodes.AdyenRefusal3DNotAuthenticated]: 'Virhe maksun varmentamisessa.',
  [PaymentsApiErrorCodes.AdyenRefusalNotEnoughBalance]: 'Maksu epäonnistui. Tilin saldo ei riitä.',
  [PaymentsApiErrorCodes.AdyenRefusalCancelled]: 'Tilaus peruutettu.',
  [PaymentsApiErrorCodes.AdyenRefusalCvcInvalid]: 'Virhe syöttämäsi maksukortin tiedoissa.',
  [PaymentsApiErrorCodes.AdyenRefusalRestrictedCard]: 'Virhe syöttämäsi maksukortin tiedoissa.',
  [PaymentsApiErrorCodes.AdyenRefusalWithdrawalAmountExceeded]: 'Maksu epäonnistui. Tilin rajoitukset ylittyivät.',
  [PaymentsApiErrorCodes.AdyenRefusalWithdrawalCountExceeded]: 'Maksu epäonnistui. Tilin rajoitukset ylittyivät.',
  [PaymentsApiErrorCodes.AdyenRefusalAuthenticationRequired]: 'Virhe käyttäjän varmentamisessa.',
  [PaymentsApiErrorCodes.AdyenRefusal3DSError]: 'Virhe maksun varmentamisessa.',
  [PaymentsApiErrorCodes.AdyenRefusalBlocked]: 'Virhe maksun varmentamisessa.',
  [PaymentsApiErrorCodes.EdenredUnauthorizedError]: 'Virhe Edenred-käyttäjän varmentamisessa.',
  [PaymentsApiErrorCodes.EdenredCardBlockedError]: 'Virhe maksukortin varmentamisessa.',
  [PaymentsApiErrorCodes.EdenredCardInvalidNumber]: 'Virheellinen maksukortin numero.',
  [PaymentsApiErrorCodes.EdenredCardNoMoneyError]: 'Tilin saldo ei riitä.',
  [PaymentsApiErrorCodes.EdenredCardExpiredError]: 'Kortti on vanhentunut.',
  [PaymentsApiErrorCodes.EdenredCardSecurityViolationError]: 'Virhe maksukortin varmentamisessa.',
  [PaymentsApiErrorCodes.EdenredCardDeclinedError]: 'Virhe maksukortin varmentamisessa.',
  [PaymentsApiErrorCodes.EdenredCardTransactionBlockedError]: 'Maksu hylätty.',
  [PaymentsApiErrorCodes.EdenredCardDoNotHonorError]: 'Virhe maksukortin varmentamisessa.',
  [PaymentsApiErrorCodes.EdenredCardNotActivatedError]: 'Korttia ei ole aktivoitu. Aktivoi kortti ja yritä uudestaan.',
  [PaymentsApiErrorCodes.EdenredComplementaryPaymentMethodNotActiveError]:
    'Edenred-tililtäsi puuttuu maksutapa lounasmaksun ylittäville maksuille.',
  [PaymentsApiErrorCodes.EdenredGatewayBlockedError]: 'Yhteysongelma Edenredin kanssa.',
  [PaymentsApiErrorCodes.EdenredGatewayTimeoutError]: 'Yhteysongelma Edenredin kanssa.',
  [PaymentsApiErrorCodes.EdenredInternalError]: 'Yhteysongelma Edenredin kanssa.',
  [PaymentsApiErrorCodes.KlarnaNoAlcoholAllowed]: 'Klarna-tilaus ei saa sisältää alkoholituotteita.',
  [PaymentsApiErrorCodes.SplitPaymentTooManyMethods]: 'Jaettu maksu sisältää liian monta maksutapaa.',
  [PaymentsApiErrorCodes.SplitPaymentTooFewMethods]: 'Jaetussa maksussa ei ole riittävästi maksutapoja.',
  [PaymentsApiErrorCodes.SplitPaymentSumMismatch]: 'Jaetun maksun maksutapojen summa ei täsmää ostokseen.',
  [PaymentsApiErrorCodes.SplitPaymentIncorrectNonLastMethod]: 'Vain viimeinen maksutapa voi olla muu kuin lahjakortti.',
  [PaymentsApiErrorCodes.SplitPaymentMethodNotSupported]: 'Maksutapa ei ole sallittu osana jaettua maksua.',
  [PaymentsApiErrorCodes.LegalEntityNotFound]: 'Yritystä ei löytynyt. Ota yhteyttä verkkokauppa tiimiin.',
  [PaymentsApiErrorCodes.GenericStoreNotFoundInDb]:
    'Ravintolaa ei löytynyt tietokannasta. Ota yhteyttä verkkokauppa tiimiin.',
  [PaymentsApiErrorCodes.GenericMerchantCreationFailed]: 'Kauppiastunnuksen luominen epäonnistui.',
  [PaymentsApiErrorCodes.GenericMerchantUpdateFailed]: 'Kauppiastunnuksen päivittäminen epäonnistui.',
  [PaymentsApiErrorCodes.GenericValidationError]: 'Virhe kutsun validoinnissa.',
  [PaymentsApiErrorCodes.GenericPaymentNotFound]: 'Maksua ei löytynyt.',
  [PaymentsApiErrorCodes.GenericInvalidOrderKey]: 'Tilauksen avain on virheellinen.',
  [PaymentsApiErrorCodes.MerchantLegalEntityMismatch]: 'Kauppiastunnuksen yritys ei täsmää ravintolan yritykseen.',
  [PaymentsApiErrorCodes.GetRestaurantLegalEntitiesError]: 'Virhe ravintoloiden yritystietojen hakemisessa.',
  [PaymentsApiErrorCodes.AdyenMerchantCreateOrFetchFailed]:
    'Adyen kauppiastunnuksen luominen tai hakeminen epäonnistui.',
  [PaymentsApiErrorCodes.AdyenBusinessLineIdNotFound]: 'Adyen liiketoiminta-entiteetin haku epäonnistui.',
  [PaymentsApiErrorCodes.AdyenUserCreateOrFetchFailed]: 'Adyen käyttäjän luominen tai hakeminen epäonnistui.',
  [PaymentsApiErrorCodes.PatchPosPaymentMethodsWithNewStoreFailed]:
    'Ravintolan päivittäminen uusilla maksutavoilla epäonnistui.',
  [PaymentsApiErrorCodes.AdyenFailedToLoadUsers]: 'Adyen käyttäjien lataaminen epäonnistui.',
  [PaymentsApiErrorCodes.AdyenFailedToActivateMerchant]: 'Adyen kauppiastunnuksen aktivointi epäonnistui.',
  [PaymentsApiErrorCodes.AdyenRestaurantNoPosMerchantAssigned]: 'Adyen ravintolalla ei ole KASSA kauppiastunnusta',
  [PaymentsApiErrorCodes.AdyenCreateStoreFailed]: 'Adyen ravintolan luominen epäonnistui.',
  [PaymentsApiErrorCodes.AdyenSaveStoreFailed]: 'Adyen ravintolan tallentaminen epäonnistui.',
  [PaymentsApiErrorCodes.AdyenOnboardingServiceError]: 'Adyen onboarding-prosessi epäonnistui.',
  [PaymentsApiErrorCodes.AdyenOnboardingGenericError]: 'Adyen onboarding-prosessi epäonnistui.',
  [PaymentsApiErrorCodes.AdyenFailedToGetPaymentMethodSettings]: 'Adyen maksutapa-asetusten haku epäonnistui.',
  [PaymentsApiErrorCodes.AdyenFailedToRequestPaymentMethods]: 'Adyen maksutavan lisääminen epäonnistui.',
  [PaymentsApiErrorCodes.AdyenFailedToPatchPaymentMethodsWithNewStore]:
    'Ravintolan päivittäminen uusilla maksutavoilla epäonnistui.',
  [PaymentsApiErrorCodes.AdyenFailedToPatchOrRequestPosPaymentMethod]:
    'Ravintolan päivittäminen uusilla maksutavoilla epäonnistui.',
  [PaymentsApiErrorCodes.AdyenWebhookError]: '',
  [PaymentsApiErrorCodes.AdyenWebhookInvalidHmac]: '',
  [PaymentsApiErrorCodes.AdyenMerchantUpdateError]: 'Adyen kauppiastunnuksen päivittäminen epäonnistui.',
  [PaymentsApiErrorCodes.AdyenMerchantCreateError]: 'Adyen kauppiastunnuksen luominen epäonnistui.',
  [PaymentsApiErrorCodes.KlarnaMerchantCreateFailed]: 'Klarna kauppiastunnuksen luominen epäonnistui.',
  [PaymentsApiErrorCodes.KlarnaCreateMerchantApiKeyFailed]:
    'Klarna kauppiastunnuksen API-avaimen luominen epäonnistui.',
  [PaymentsApiErrorCodes.KlarnaMerchantSaveFailed]: 'Klarna kauppiastunnuksen päivittäminen epäonnistui.',
  [PaymentsApiErrorCodes.KlarnaMerchantCreateOnboardingWidgetUrlFailed]:
    'Klarna kauppiastunnuksen onboarding-linkin luominen epäonnistui.',
  [PaymentsApiErrorCodes.KlarnaMerchantSendOnboardingEmailFailed]:
    'Klarna kauppiastunnuksen onboarding-linkin lähettäminen sähköpostilla epäonnistui.',
  [PaymentsApiErrorCodes.MarkGiftCardOrderAsPaidError]: '',
  [PaymentsApiErrorCodes.MarkGiftCardOrderAsPaidAlreadyInProcessingError]: 'Lahjakorttitilaus on jo käsittelyssä.',
  [PaymentsApiErrorCodes.EPassiUnauthorizedError]: 'Virhe Epassi-käyttäjän varmentamisessa.',
  [PaymentsApiErrorCodes.EPassiNoWalletToken]: 'Epassi-maksuvälinettä ei löytynyt.',
  [PaymentsApiErrorCodes.EPassiPaymentError]: 'Virhe Epassi-maksussa.',
  [PaymentsApiErrorCodes.EPassiNoFunds]: 'Tilin saldo ei riitä.',
  [PaymentsApiErrorCodes.EPassiExpiredToken]: 'Epassi-maksuväline on vanhentunut.',
  [PaymentsApiErrorCodes.EPassiTokenDeactivated]: 'Epassi-maksuväline ei ole käytössä.',
  [PaymentsApiErrorCodes.EPassiNoSuchToken]: 'Epassi-maksuvälinettä ei löytynyt.',
  [PaymentsApiErrorCodes.EPassiCustomerAccountNotActive]: 'Epassi-tili ei ole aktiivinen.',
  [PaymentsApiErrorCodes.EPassiNoFundingSourceSupportsSite]:
    'Epassi-tililtäsi puuttuu maksutapa, joka kelpaa tässä ravintolassa.',
  [PaymentsApiErrorCodes.EPassiDuplicatedTransaction]: 'Maksu on jo käsitelty.',
  [PaymentsApiErrorCodes.EPassiCountryNotSupported]: 'Epassi-maksu ei ole käytettävissä tässä maassa.',
  [PaymentsApiErrorCodes.EPassiSignatureVerificationFailed]: 'Virhe Epassi-maksun varmentamisessa.',
  [PaymentsApiErrorCodes.EPassiSiteNotActive]: 'Epassi-maksu ei ole käytössä tässä ravintolassa.',
  [PaymentsApiErrorCodes.EPassiApiKeyInvalid]: 'Yhteysongelma Epassin kanssa.',
  [PaymentsApiErrorCodes.EPassiTransactionFailed]: 'Epassi-maksu epäonnistui.',
};

export function isPaymentsApiErrorResponse(obj: unknown): obj is PaymentsApiErrorResponse {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  const maybe = obj as Partial<PaymentsApiErrorResponse>;

  const isValidErrorCode = Object.values(PaymentsApiErrorCodes).includes(maybe.errorCode as PaymentsApiErrorCodes);
  const isValidErrorData = Array.isArray(maybe.errorData);
  const isValidErrorMessage =
    maybe.errorMessage === undefined || maybe.errorMessage === null || typeof maybe.errorMessage === 'string';

  return isValidErrorCode && isValidErrorData && isValidErrorMessage;
}

export const getPaymentsApiErrorMessage = (code?: PaymentsApiErrorCodes | null): string => {
  if (code) {
    return paymentsApiErrorMessages[code];
  }
  return paymentsApiErrorMessages[PaymentsApiErrorCodes.GenericUnknownError];
};

export const getPaymentsApiError = (error: unknown): PaymentsApiError => {
  if (error instanceof PaymentsApiError) return error;

  if (PaymentsApiException.isPaymentsApiException(error)) {
    error = error.response;
  }

  if (!isPaymentsApiErrorResponse(error)) {
    return new PaymentsApiError(
      paymentsApiErrorMessages[PaymentsApiErrorCodes.GenericUnknownError],
      PaymentsApiErrorCodes.GenericUnknownError
    );
  }

  return new PaymentsApiError(paymentsApiErrorMessages[error.errorCode], error.errorCode);
};

export class PaymentsApiError extends Error {
  public errorCode: PaymentsApiErrorCodes | null;
  constructor(errorMessage: string, errorCode: PaymentsApiErrorCodes | null) {
    super(errorMessage);
    this.errorCode = errorCode;
  }
}
